import { Button, Modal } from 'react-bootstrap';


export default function ConfirmReleaseUnsavedChanges({ show, onHide, onConfirm }) {
  return (
    <Modal className="modal-confirm" onHide={onHide} animation show={show}>
      <Modal.Header closeButton>
        <Modal.Title>You Have Unsaved Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You have unsaved changes that will be lost if you decide to continue.
        </p>
        <p>
          Are you sure you want to leave this page?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>
          CONTINUE EDITING
        </Button>
        <Button onClick={onConfirm} bsStyle="primary">
          LEAVE & DISCARD CHANGES
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
